import { z } from 'zod';

export const MediaRowMappingExtraSchema = z
  .object({
    appsflyer_device_platform: z.string().optional(),
    adform_external_uuid: z.string().optional(),
    adform_is_rtb: z.boolean().optional(),
    campaign_manager_advertiser_id: z.string().optional(),
    platform_id: z.string().optional(),
    platform_name: z.string().optional(),
  })
  .nullable();

export const CreateMediaRowMappingItemSchema = z.object({
  id: z.string(),
  settingsId: z.string(),
  name: z.string(),
  externalId: z.string(),
  type: z.string(),
  status: z.string(),
  taxonomyItemId: z.string(),
  extra: MediaRowMappingExtraSchema,
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});
